export const AUTH_RESPONSE_CODES = {
  SESSION_EXPIRED: 3001,
  SESSION_INVALID: 3002,
  INVITE_ONLY: 3004,
  SINGLE_LOGIN_CONFLICT: 3005,
} as const;
